<template>
  <section
    class="flex flex-row w-full gap-x-3 gap-y-1 md:items-center border-b border-dashed border-gray py-4 px-6 relative"
  >
    <div class="flex flex-col md:flex-row md:items-center flex-1 gap-y-2">
      <div class="flex flex-col">
        <h2 class="text-xl font-semibold md:flex-1 m-0">
          Order {{ item.orderNumber }}
        </h2>

        <!-- Order Date -->
        <time
          class="font-medium text-sm"
          :datetime="item.createdAt"
        >
          {{ dateFormatter.formatShortDate(item.createdAt) }}
        </time>
      </div>

      <!-- Order Status -->
      <div class="flex md:justify-end flex-1 pr-3 gap-3">
        <template v-if="authStore.user?.isAdmin && showEditButton && item.hasPrintItems">
          <AppButton
            class="p-0"
            @click="$emit('editButtonClicked')"
          >
            Edit
          </AppButton>
        </template>

        <p
          class="rounded px-2 py-0.5 font-medium whitespace-nowrap m-0 md:static text-[15px] w-fit h-fit text-black bg-gray-light"
          :class="item?.status === 'Awaiting Payment' ? 'text-red-600 bg-red-200' :
            item?.status === 'Processing' ? '!bg-[#A2D5FF]' : ''"
        >
          {{ item?.status }}
        </p>
      </div>

      <div
        v-if="showDetailsButton"
        class=" flex items-center md:justify-end"
      >
        <AppLink
          :to="{ name: 'app_order_details', params: { order: item.id} }"
          class="w-fit text-sm md:!text-[15px] !px-2 xs:!px-4 border border-gray hover:bg-secondary-light hover:text-white hover:border-secondary-light py-1.5 font-medium rounded-none"
        >
          View order details
        </AppLink>
      </div>
    </div>
  </section>
</template>

<script setup>

import { AppLink, AppButton } from '@/components/app';

import { useDateFormatter } from '@/composables';

import { useAuthStore } from '@/store';

const authStore = useAuthStore();

const dateFormatter = useDateFormatter();

defineProps({
  item: Object,
  showDetailsButton: {
    type: Boolean,
    default: true,
  },
  showEditButton: Boolean,
});

defineEmits(['editButtonClicked']);
</script>
